import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

export const initializeUser = createAsyncThunk(
  'user/initialize',
  async (initData) => {
    const response = await fetch(`${process.env.REACT_APP_WEBAPP_URL}/api/user-info`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ initData }),
    });
    
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    
    const data = await response.json();
    return data;
  }
);

export const userSlice = createSlice({
  name: 'user',
  initialState: {
    initData: null,
    userData: null,
    isNewUser: null,
    loading: true,
    error: null,
    deathDate: null,
    imageName: null,
    advices: null,
    deathReasons: null,
    language: null,
    showPaidLoadingScreen: false,
    isPaid: false,
    optimisticAge: null,
  },
  reducers: {
    setInitData: (state, action) => {
      state.initData = action.payload;
    },
    updateSubscriptionStatus: (state) => {
      state.userData = {
        ...state.userData,
        subscription_active: true,
        subscription_expiry: new Date(Date.now() + 21 * 24 * 60 * 60 * 1000).toISOString()
      };
    },
    updatePoints: (state, action) => {
      state.userData = {
        ...state.userData,
        points: action.payload
      };
    },
    setDeathDate: (state, action) => {
      state.deathDate = action.payload;
    },
    setImageName: (state, action) => {
      state.imageName = action.payload;
      if (state.userData) {
        state.userData.image_name = action.payload;
      }
    },
    updateUserData: (state, action) => {
      console.log('🔄 updateUserData вызван с данными:', action.payload);
      
      if (!action.payload) {
        console.error('❌ Пустые данные в updateUserData');
        return;
      }

      // Создаем копию payload без поля language
      const { language: _, ...payloadWithoutLanguage } = action.payload;

      // Обновляем данные без изменения языка
      state.userData = {
        ...state.userData,
        ...payloadWithoutLanguage,
        advices: payloadWithoutLanguage.advices || null,
        death_reasons: payloadWithoutLanguage.death_reasons || null,
        subscription_active: payloadWithoutLanguage.subscription_active || false
      };

      // Отдельно обновляем advices и deathReasons
      state.advices = payloadWithoutLanguage.advices || null;
      state.deathReasons = payloadWithoutLanguage.death_reasons || null;

      console.log('📊 Обновленное состояние:', state);
    },
    setLanguage: (state, action) => {
      console.log('🌍 Меняем язык на:', action.payload);
      state.language = action.payload;
    },
    initializeLanguage: (state, action) => {
      console.log('🌍 Инициализируем язык из TG:', action.payload);
      if (!state.language) {
        state.language = action.payload === 'ru' ? 'RUS' : 'ENG';
      }
    },
    setShowPaidLoadingScreen: (state, action) => {
      state.showPaidLoadingScreen = action.payload;
    },
    setIsPaid: (state, action) => {
      state.isPaid = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(initializeUser.pending, (state) => {
        console.log('🔄 initializeUser.pending');
        state.loading = true;
      })
      .addCase(initializeUser.fulfilled, (state, action) => {
        console.log('✅ initializeUser.fulfilled:', action.payload);
        const currentLanguage = state.language;

        state.loading = false;
        state.isNewUser = action.payload.is_new_user;
        state.deathDate = action.payload.death_date;
        state.imageName = action.payload.image_name;
        state.advices = action.payload.advices || null;
        state.deathReasons = action.payload.death_reasons || null;
        state.optimisticAge = action.payload.optimistic_age || null;

        const { language: _, ...payloadWithoutLanguage } = action.payload;

        state.userData = {
          ...payloadWithoutLanguage,
          image_name: payloadWithoutLanguage.image_name || state.imageName,
          advices: payloadWithoutLanguage.advices || null,
          death_reasons: payloadWithoutLanguage.death_reasons || null,
          optimistic_age: payloadWithoutLanguage.optimistic_age || null
        };

        state.language = currentLanguage;
        
        console.log('📊 Обновленное состояние:', state);
      })
      .addCase(initializeUser.rejected, (state, action) => {
        console.log('❌ initializeUser.rejected:', action.error);
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { 
  setInitData, 
  updateSubscriptionStatus, 
  updatePoints, 
  setDeathDate,
  setImageName,
  setLanguage,
  initializeLanguage,
  setShowPaidLoadingScreen,
  setIsPaid,
} = userSlice.actions;

export default userSlice.reducer;